import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function PageOg() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    fetch(`https://respublica-backend.onrender.com/article/${id}`)
      .then(res => res.json())
      .then(data => {
        const a =
          Array.isArray(data) ? data[0] :
          data?.article ? data.article :
          data;

        setArticle(a);
      });
  }, [id]);

  if (!article) return null;

  const title = article.article_title || "Respublica";
  const description = article.description || "";

  const imageUrl =
    article.image ||
    "https://respublica.com.pl/og-image.jpg";

  const url = `https://respublica.com.pl/artykuł/${id}`;

  return (
    <html>
      <head>
        <meta charSet="utf-8" />
        <title>{title}</title>

        {/* SEO */}
        <link rel="canonical" href={url} />

        {/* Open Graph */}
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="Respublica" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={imageUrl} />
        <meta property="og:url" content={url} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={imageUrl} />
      </head>

      <body>
        {/* optional redirect dla usera */}
        <script>
          {`window.location.href="${url}"`}
        </script>
      </body>
    </html>
  );
}